import { UNSTRICT_WS, UNSTRICT_WS_ERROR, UNSTRICT_WS_SUCCESS} from './actionTypes';

export const unstrictWorkstations = ( ws, token, history) => {
    return {
        type: UNSTRICT_WS,
        payload: { ws, token, history }
    }
}

export const unstrictWorkstationsSuccess = (message) => {
    return {
        type: UNSTRICT_WS_SUCCESS,
        payload: {message}
    }
}

export const unstrictWorkstationsError = (ws) => {
    return {
        type: UNSTRICT_WS_ERROR,
        payload: ws
    }
}
